
<div [class]="wrapperClass">
  <div class="font-semibold">{{title}}</div>
  <div>{{value || '-'}}</div>
</div>